import { createSlice } from "@reduxjs/toolkit"

const status_slices = {
    WAITING: 'waiting',
    PROCESSING: 'processing_request',
    LOADED: 'loaded',
    NOT_LOADED: 'not_loaded',
    ERROR: 'error',
    SUCCESS: 'success'
};

export const customerDetail = createSlice({
    name: 'customerDetail',
    initialState: {
        isLoading: true,
        status: status_slices.SUCCESS,
        msg: '',
        idCustomer: '', //4172
        indicators: [],
        dataCustomer: [],
        devices: [],
        memberships: [],
        billings: [],
        orders: [],
        order: [],
        sales: [],
    },
    reducers: {

        setMemberships: (state, action) => {
            state.isLoading = false;
            state.msg = 'Membresias Cargado';
            state.memberships = action.payload.memberships;
        },
        clearMemberships: (state, action) => {
            state.isLoading = false;
            state.msg = 'Membresias Limpios';
            state.memberships = [];
        },
        setListMemberships: (state, action) => {
            state.isLoading = false;
            state.msg = 'Catalogo Membresias Cargado';
            state.catMemberships = action.payload.catMemberships;
        },
        clearListMemberships: (state, action) => {
            state.isLoading = false;
            state.msg = 'Catalogo Limpios';
            state.catMemberships = [];
        },
        setCustomerID: (state, action) => {
            state.isLoading = false;
            state.msg = 'Cliente Cargado';
            state.idCustomer = action.payload.idCustomer;
        },
        setCustomerClearID: (state, action) => {
            state.isLoading = false;
            state.msg = 'Cliente Limpio';
            state.idCustomer = '';
        },
        setIndicators: (state, action) => {
            state.isLoading = false;
            state.msg = 'Indicadores Cargado';
            state.indicators = action.payload.indicators;
        },
        clearIndicators: (state, actions) => {
            state.isLoading = false;
            state.msg = 'Cliente limpio';
            state.indicators = [];
        },
        setCustomer: (state, action) => {
            state.isLoading = false;
            state.msg = 'Cliente Cargado';
            state.dataCustomer = action.payload.dataCustomer;
        },
        clearCustomer: (state, actions) => {
            state.isLoading = false;
            state.msg = 'Cliente limpio';
            state.dataCustomer = [];
        },
        setDevices: (state, action) => {
            state.isLoading = false;
            state.msg = 'Equipos cargados';
            state.devices = action.payload.devices;
        },
        clearDevices: (state, action) => {
            state.isLoading = false;
            state.msg = 'Equipos Limpios';
            state.devices = [];
        },
        setBillings: (state, action) => {
            state.isLoading = false;
            state.msg = 'Facturacion cargados';
            state.billings = action.payload.billings;
        },
        clearBillings: (state, action) => {
            state.isLoading = false;
            state.msg = 'Facturacion Limpios';
            state.billings = [];
        },
        setOrders: (state, action) => {
            state.isLoading = false;
            state.msg = 'Ordenes cargadas';
            state.orders = action.payload.orders;
        },
        clearOrders: (state, action) => {
            state.isLoading = false;
            state.msg = 'Ordenes Limpias';
            state.orders = [];
        },
        setOrderDetail: (state, action) => {
            state.isLoading = false;
            state.msg = 'Orden cargadas';
            state.order = action.payload.order;
        },
        clearOrderDetail: (state, action) => {
            state.isLoading = false;
            state.msg = 'Orden Limpias';
            state.order = [];
        },
        setSales: (state, action) => {
            state.isLoading = false;
            state.msg = 'Ventas cargados';
            state.sales = action.payload.sales;
        },
        clearSales: (state, action) => {
            state.isLoading = false;
            state.msg = 'Ventas Limpios';
            state.sales = [];
        },
        // Reducers Estaticos
        processRequest: (state, action) => {
            state.isLoading = true;
            state.status = status_slices.PROCESSING;
        },
        notProcessRequest: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
        },
        setError: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.ERROR;
            state.msg = "";
        },
    }
});

export const { setMemberships, clearMemberships, setListMemberships, clearListMemberships, setCustomerID, setCustomerClearID, setIndicators, clearIndicators, setBillings, clearBillings, setOrderDetail, clearOrderDetail, setSales, clearSales, setOrders, clearOrders, setCustomer, clearCustomer, setDevices, processRequest, notProcessRequest, setError, clearDevices } = customerDetail.actions;